import React from 'react';
import ArrowUp from './ArrowUp';
import Calendar from './Calendar';
import Camera from './Camera';
import Chevron from './Chevron';
import CirclePlus from './CirclePlus';
import Close from './Close';
import Dashboard from './Dashboard';
import Download from './Download';
import Edit from './Edit';
import Gear from './Gear';
import Key from './Key';
import LockOpen from './LockOpen';
import Logout from './Logout';
import Menu from './Menu';
import MailCog from './MailCog';
import People from './People';
import PeopleBold from './PeopleBold';
import Peoples from './Peoples';
import Trash from './Trash';
import TrashX from './TrashX';
import Upload from './Upload';
import Search from './Search';
import StarBubble from './StarBubble';

export type IconName = 'ArrowUp' | 'Calendar' | 'Camera'
  | 'Chevron' | 'CirclePlus' | 'Close'
  | 'Dashboard' | 'Download' | 'Edit' | 'Gear' | 'Key' 
  | 'LockOpen' | 'Logout' | 'MailCog' | 'Menu'
  | 'People' | 'PeopleBold' | 'Peoples'
  | 'Trash' | 'TrashX' | 'Upload' | 'Search' | 'StarBubble';

type IconProps = React.SVGProps<SVGSVGElement> & {
  name: IconName;
};

const icons = {
  ArrowUp,
  Calendar,
  Camera,
  Chevron,
  CirclePlus,
  Close,
  Dashboard,
  Download,
  Edit,
  Gear,
  Key,
  LockOpen,
  Logout,
  MailCog,
  Menu,
  People,
  PeopleBold,
  Peoples,
  Trash,
  TrashX,
  Upload,
  Search,
  StarBubble
};

const Icon: React.FC<IconProps> = ({ name, ...props }) => {
  const Component = icons[name];
  return Component ? <Component {...props} /> : null;
};

export default Icon;